import { CalendarItemType } from '$tablet-app/src/app/models';
import { Palette, palette } from './palette';

/**
 * Roles for colors.  Prefer using these over the palette.  It makes it easier
 * to change things.
 *
 * The only roles we need to place in here are the ones that span through the app.
 *
 * If you have a specific use-case, like a spinner color.  It makes more sense to
 * put that in the <Spinner /> component.
 */
export const color: Palette = {
  /**
   * The screen background.
   */
  background: palette.white,

  /**
   * The main tinting color.
   */
  primary: palette.Primary_blue,
  /**
   * The main tinting color.
   */
  secondary: palette.Background_blue,
  /**
   * The main tinting color, but darker.
   */
  // tertiary: palette.blue,
  tertiary: palette.white,

  /**
   * The main tinting color.
   */
  primaryText: palette.white,
  /**
   * The main tinting color.
   */
  secondaryText: palette.Primary_blue,
  /**
   * The main tinting color, but darker.
   */
  // tertiary: palette.blue,
  tertiaryText: palette.Primary_blue,

  /**
   * The main tinting color.
   */
  primaryIcon: palette.Secondary_blue,
  /**
   * The main tinting color.
   */
  secondaryIcon: palette.Secondary_blue,
  /**
   * The main tinting color, but darker.
   */
  // tertiary: palette.blue,
  tertiaryIcon: palette.Secondary_blue,
  /**
   * The main tinting color, but darker.
   */
  // tertiary: palette.blue,
  tertiaryText2: palette.Dark_gray,

  /**
   * The main tinting color, but darker.
   */
  primaryDarker: palette.Primary_blue,
  // /**
  //  * A subtle color used for borders and lines.
  //  */
  // line: palette.offWhite,
  /**
   * The default color of text in many components.
   */
  text: palette.Dark_gray,
  /**
   * Secondary information.
   */
  dim: palette.Dark_blue,
  /**
   * Input box border color
   */
  formElement: palette.Outline_blue,

  border: palette.Outline_blue,

  /**
   * Storybook background for Text stories, or any stories where
   * the text color is color.text, which is white by default, and does not show
   * in Stories against the default white background
   */
  storybookDarkBg: palette.black,

  /**
   * Storybook text color for stories that display Text components against the
   * white background
   */
  storybookTextColor: palette.black,

  alarm: palette.Mango_yellow,
  alert: palette.Pine_green,
  event: palette.Secondary_blue,
  goal: palette.Primary_blue,
  meal: palette.Orange_crayola,
  white: palette.white,
};

export const calendarItemColors: Record<CalendarItemType, string> = {
  Event: '#dbf1ff',
  Goal: '#d9defb',
  Meal: '#ffebe4',
  Alert: '#e2f1ee',
  Alarm: '#fff5d9',
};
